import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";

const FormList = ({ formList, onMouseDown, tableRef, selectedFormIds, setSelectedFormIds, reviewSettingForm }) => {

  const handleChange = (formId) => {
    setSelectedFormIds((prev) => {
      if (prev.includes(formId)) {
        return prev.filter((id) => id !== formId);
      }
      return [...prev, formId];
    });
  };

  const isAllSelected =
    formList?.length > 0 &&
    formList.every((item) =>
      selectedFormIds.includes(item.formId)
    );

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedFormIds([]);
    } else {
      setSelectedFormIds(formList.map((item) => item.formId));
    }
  };
  
  return (
    <>
        <Table ref={tableRef} className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th className="text-center" style={{ width: "50px" }}>
                <Form.Check
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
              </th>

              <th onMouseDown={(e) => onMouseDown(e, 0)}>
                Form Name
              </th>

              <th onMouseDown={(e) => onMouseDown(e, 1)}>
                Form Label
              </th>

              <th onMouseDown={(e) => onMouseDown(e, 2)}>
                Version
              </th>
            </tr>
          </thead>

          <tbody>
            {formList?.map((metadata, index) => (
              <tr key={index}>
                <td className="text-center">
                  <Form.Check
                    type="checkbox"
                    disabled={reviewSettingForm?.includes(metadata.formId)}
                    checked={selectedFormIds.includes(metadata.formId)}
                    onChange={() => handleChange(metadata.formId)}
                  />
                </td>

                <td>{metadata?.formName}</td>

                <td>{metadata?.formLabel}</td>

                <td>{metadata?.version}</td>
              </tr>
            ))}
          </tbody>
        </Table>
    </>
  );
};

export default FormList;
